import { Outlet, useLocation, useParams, Navigate } from "react-router-dom";
import {
  defaultLocale,
  getLocaleDirection,
  isSupportedLocale,
  type PortalLocale,
} from "@/lib/i18n/portal";
import { AdminIntlProvider } from "@/lib/i18n/intl-provider";
import { AdminToastProvider } from "@/shared/layout/AdminToastProvider";
import { useApplyTheme } from "@/shared/theme/useTheme";

export function getResolvedAdminLocale(value: string | undefined): PortalLocale {
  return value && isSupportedLocale(value) ? value : defaultLocale;
}

export function useLocale() {
  const { locale } = useParams();
  return getResolvedAdminLocale(locale);
}

export function AdminLocaleLayout() {
  const { locale } = useParams();
  const location = useLocation();
  const resolvedLocale = getResolvedAdminLocale(locale);
  useApplyTheme();

  if (locale !== resolvedLocale) {
    const suffix = location.pathname.replace(/^\/[^/]+/, "") || "/admin/login";
    return <Navigate to={`/${resolvedLocale}${suffix}${location.search}`} replace />;
  }

  return (
    <AdminIntlProvider locale={resolvedLocale}>
      <AdminToastProvider>
        <div
          className="admin-app"
          lang={resolvedLocale}
          dir={getLocaleDirection(resolvedLocale)}
        >
          <Outlet />
        </div>
      </AdminToastProvider>
    </AdminIntlProvider>
  );
}
